import { render, staticRenderFns } from "./textTitle4.vue?vue&type=template&id=b07e8624&scoped=true"
import script from "./textTitle4.vue?vue&type=script&lang=js"
export * from "./textTitle4.vue?vue&type=script&lang=js"
import style0 from "./textTitle4.vue?vue&type=style&index=0&id=b07e8624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e8624",
  null
  
)

export default component.exports